import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '../common/bottom-modal-message';
import { NOJOOM_STATUS_COLORS, SELECTED_LANG } from '../../services/common/Constants';
import { getItemOfSessionStorage } from '../../services/common/utils';

const progressBarCss = {
  RED: '',
  SILVER: 'progress1',
  GOLD: 'progress2',
  NOKHBA: 'progress3',
};

const progressLevelCss = {
  RED: '',
  SILVER: 'progress1-value',
  GOLD: 'progress2-value',
  NOKHBA: 'progress3-value',
};

const NojoomDashboardStatus = ({ data }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const lang = getItemOfSessionStorage(SELECTED_LANG);
  const mSISDNIdInfo =
    data?.response?.ListOfMSISDNLoyMember?.length > 0
      ? data?.response?.ListOfMSISDNLoyMember[0]
      : null;

  const toggleMessageModal = () => {
    setShowModal(!showModal);
  };

  const NojoomStatusBar = (type, tierLevel) => {
    let shouldShow = false;
    if (mSISDNIdInfo?.TierLevel?.toUpperCase() === tierLevel) {
      shouldShow = true;
    }

    let percentage = 0;

    percentage =
      (parseInt(mSISDNIdInfo?.CurrentStar) /
        (parseInt(data?.response?.NextTierStars) +
          parseInt(mSISDNIdInfo?.CurrentStar))) *
      100;

    if (isNaN(percentage)) {
      percentage = 0;
    }

    if (percentage < 0) {
      percentage = 0;
    }

    let percentageToPx = (74 * percentage) / 100;

    return (
      <div className={`progress ${progressBarCss[type]}`}>
        <div
          className="progress-done"
          data-done="50"
          style={{ marginLeft: lang === 'en' ? percentageToPx : '', marginRight: lang === 'ar' ? percentageToPx : '' }}
        >
          {shouldShow && <div className="progress-thumb" style={{
            backgroundColor: NOJOOM_STATUS_COLORS[mSISDNIdInfo?.TierLevel?.toUpperCase()],
            border: '3px solid',
            borderColor: NOJOOM_STATUS_COLORS[mSISDNIdInfo?.TierLevel?.toUpperCase()],
            left: '0px',
            right: '0px'
          }}></div>}

        </div>
        <div className={`progress-value ${progressLevelCss[type]}`}>
          {t(type.toLowerCase())}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <div>
        <div className="white_card p-3 mb-5">
          <h3 className="section_title_light text-center mb-0">
            {t('nozmstatus')}
          </h3>
          <div className="usage-bar">
            <div className="progress-bar-wrap d-flex">
              {NojoomStatusBar('RED', 'RED')}
              {NojoomStatusBar('SILVER', 'SILVER')}
              {NojoomStatusBar('GOLD', 'GOLD')}
              {NojoomStatusBar('NOKHBA', 'AL NOKHBA')}
            </div>
          </div>

          <div>
            <div className="grey_badge d-flex justify-content-center">
              <label>{data?.response?.Messages['62002'] || ''}</label>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/help_sm.svg'}
                alt=""
                title=""
                class="ms-2 pointer"
                data-bs-toggle="modal"
                data-bs-target=".popup2"
                onClick={toggleMessageModal}
              />
            </div>
          </div>
        </div>
      </div> */}

      <div>
        <div className="white_card p-3 mb-4">
          <h3 className="section_title_light text-center mb-0">
            {t('nozmstatus')}
          </h3>
          <div className="usage-bar">
            <div className="progress-bar-wrap d-flex">
              {NojoomStatusBar('RED', 'RED')}
              {NojoomStatusBar('SILVER', 'SILVER')}
              {NojoomStatusBar('GOLD', 'GOLD')}
              {NojoomStatusBar('NOKHBA', 'AL NOKHBA')}
            </div>
          </div>
          <div>
            <div className="grey_badge d-flex justify-content-center">
              <label>{data?.response?.Messages['62002'] || ''}</label>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/help_sm.svg'}
                alt=""
                title=""
                class="ms-2 pointer"
                onClick={toggleMessageModal}
              />
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        show={showModal}
        toggleModal={toggleMessageModal}
        title={data?.response?.silverpopup?.title || ''}
        message={data?.response?.silverpopup?.description}
      />
    </>
  );
};

export default NojoomDashboardStatus;
